import { ALLOWED_NAME_CHARACTER_REGEXP } from "@mrdm-self-service-frontend/shared/validators";

export function simpleCodeGenerator(name: string): string {
    if (!name.match(ALLOWED_NAME_CHARACTER_REGEXP) || !name.length) return "";

    // acronyms with 1 or 2 characters, these will be written in uppercase
    if (name.match(/^([a-z]|[A-Z]){1,2}$/)) {
        return name.toUpperCase();
    }

    const words = name.split(/-| /).filter(i => i);
    const lowerCasedWords = words.map(w => lowerCase(w));
    const finalWords = lowerCasedWords.map(w => w.replace(/^./, w[0].toUpperCase()));
    return finalWords.join("");
}

function lowerCase(word: string): string {
    return isShortAcronym(word) ? word : word.toLowerCase();
}

function isShortAcronym(word: string): boolean {
    return word.length > 0 && word.length < 3 && /^[A-Z]*$/.test(word);
}
